module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/5acd13d114f21425b81ad9feba3dca63.png";